import { render, staticRenderFns } from "./SetPrice.vue?vue&type=template&id=9164d1b0&scoped=true&"
import script from "./SetPrice.vue?vue&type=script&lang=js&"
export * from "./SetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9164d1b0",
  null
  
)

export default component.exports